<template>
    <div class="recover-pass container">
        <GoToBack />
        <div class="recover-pass-content">
            <h1 class="v-content-recover-account" v-contentRecoverAccount="{ section: 'Form', removeHtml: true }">Recuperação de conta</h1>
            <h3 class="v-content-recover-account" v-contentRecoverAccount="{ section: 'Form', removeHtml: true }">Indique o seu email para proceder a recuperação da sua palavra-passe</h3>
            <form @submit.prevent="recover()">
                <div class="form-group">
                    <label for="email" class="v-content-recover-account" v-contentRecoverAccount="{ section: 'Form', removeHtml: true }">Email Recover</label>
                    <input type="email" id="email" name="email" v-model="email" placeholder="" required>
                </div>
                <button type="submit" class="v-content-recover-account" v-contentRecoverAccount="{ section: 'Form', removeHtml: true }">Recuperar</button>
            </form>
        </div>
    </div>
</template>

<script>
import GoToBack from '@/components/buttons/GoToBack.vue'
import axios from 'axios';
import store from "@/store";
import { mapState } from 'vuex';

const allContents = [];
const lang = localStorage.getItem('locale') || 'es';

export default {
    data() {
        return {
            email: '',
        }
    },
    components: {
        GoToBack
    },
    computed: {
        ...mapState('App', ['loading', 'user']),
    },
    watch: {
        user: {
            handler(newValue) {
                if (newValue) {
                    this.email = newValue?.user?.data?.email || '';
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        async recover() {
            store.dispatch('App/loading', true);
            try {
                const response = await axios.post('/api/v1/user/recover-pass', {
                    email: this.email,
                    lang: lang
                });
                
                store.dispatch('App/loading', false);

                if (response.data.success) {
                    localStorage.setItem('hash', response.data.data.hash);
                    this.$router.push('/validacion-de-restablecimiento-de-cuenta');
                } else {
                    this.$swal.fire({
                        icon: 'error',
                        title: 'Erro',
                        text: 'Ocorreu um erro ao recuperar a conta!',
                        timer: 5000,
                    });
                }
            } catch (error) {
                console.error(error);
                store.dispatch('App/loading', false);
                this.$swal.fire({
                    icon: 'error',
                    title: 'Erro',
                    text: 'Ocorreu um erro ao recuperar a conta!',
                    timer: 5000,
                });
            }
        },
        updateDirectives() {
            const allElements = document.querySelectorAll('.v-content-recover-account');
            allContents.splice(0, allContents.length); // clear the contents array
            allElements.forEach((el) => {
                const params = el.dataset.params ? JSON.parse(el.dataset.params) : {};
                params.content = el.innerHTML.trim();
                if (!('type' in params)) params.type = 'text';
                params.theme = process.env.VUE_APP_THEME;
                params.url_full = `${document.location.protocol}//${document.location.hostname}${document.location.pathname}`;
                allContents.push(params);
            });
        },
    },
    created() {
        this.updateDirectives();
    },
    directives: {
        contentRecoverAccount: {
            inserted: async function (el, binding) {
                const allElements = document.querySelectorAll('.v-content-recover-account');
                let params = binding.value ? binding.value : {};
                params.content = el.innerHTML.trim();
                if (!('type' in params)) params.type = 'text';
                params.theme = process.env.VUE_APP_THEME;
                params.url_full = `${document.location.protocol}//${document.location.hostname}${document.location.pathname}`;
                allContents.push(params);

                if (allElements.length == allContents.length) {
                    store.dispatch('App/loading', true);
                    await axios({
                        method: "POST",
                        url: '/api/v1/site/get-all-contents',
                        data: { allContents, lang }
                    })
                    .then(response => response.data)
                    .then((data) => {
                        const allElements = document.querySelectorAll('.v-content-recover-account');
                        allContents.forEach((el) => {
                            if (el.type == 'text') {
                                allElements.forEach((el, index) => {
                                    el.innerHTML = data.data[index];
                                });
                            }
                        });
                        store.dispatch('App/loading', false);
                    });
                }
            },
        }
    },
}
</script>

<style lang="scss">
.recover-pass {
    padding: 150px 15px 200px;
    &-content {
        height: 341px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-between;
        @media screen and (max-width: 768px) {
            height: auto;
            gap: 50px;
        }
        h1 {
            font-size: 35px;
            font-family: 'Font Bold';
            color: #E84E0F;
            text-align: left;
        }
        
        h3 {
            font-size: 25px;
            color: #000;
            font-family: 'Font Regular';
            text-align: left;
        }
        
        form {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            gap: 30px;
            width: 100%;
            @media screen and (max-width: 768px) {
                gap: 50px;
                align-items: center;
            }
            .form-group {
                display: flex;
                align-items: center;
                margin-bottom: 20px;
                @media screen and (max-width: 768px) {
                    flex-direction: column;
                    align-items: flex-start;
                    width: 100%;
                }
                label {
                    font-size: 16px;
                    font-family: 'Font Medium';
                    margin-bottom: 5px;
                    margin-right: 150px; /* Espaço entre o label e o input */
                    @media screen and (max-width: 768px) {
                        margin-right: 0;
                    }
                }
                
                input {
                    height: 50px;
                    width: 398px;
                    flex: 1; /* Faz o input ocupar o restante do espaço */
                    padding: 0 15px;
                    border: 2px solid #AEAEAE;
                    border-radius: 10px;
                    font-size: 16px;
                    &:focus {
                        border-color: #000;
                    }
                    @media screen and (max-width: 768px) {
                        flex: none;
                        width: 100%;
                    }
                }
            }
            
            button {
                height: 71px;
                width: 328px;
                max-width: 100%;
                background-color: var(--main-color);
                color: #fff;
                font-size: 25px;
                font-family: 'Font Regular';
                border: none;
                border-radius: 7px;
                cursor: pointer;
                
                &:hover {
                    background-color: #AEAEAE;
                }
            }
        }
    }
}
</style>
